global.SC_DISABLE_SPEEDY = true
